import type { ReactNode } from 'react';

// Small uppercase accent highlight tag for a carrier-bid row (e.g. winner /
// cheapest). Presentational and label-driven — the localized text is passed in
// by the caller, so this component holds no i18n or domain logic.
export interface RateHighlightProps {
  label: ReactNode;
}

export function RateHighlight({ label }: RateHighlightProps) {
  return (
    <span
      style={{
        fontSize: 10,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        fontWeight: 600,
        color: 'var(--accent-1-press)',
      }}
    >
      {label}
    </span>
  );
}
